export default __webpack_public_path__ + "static/media/qr.c04ef849.jpg";